import React from 'react';
export function AboutSection() {
  return <section className="bg-brand-cream px-4 py-20" data-id="element-18">
      <div className="mx-auto max-w-3xl text-center" data-id="element-19">
        <div className="mb-6 text-4xl" aria-hidden="true" data-id="element-20">
          🧘‍♀️
        </div>
        <h2 className="mb-8 text-3xl font-black text-brand-text" data-id="element-21">
          Über Yoga Bereit
        </h2>
        <p className="text-lg leading-relaxed text-brand-gray" data-id="element-22">
          Wir sind mit einer klaren Mission gestartet: Yogalehrerinnen in
          Deutschland ihre Zeit und ihren inneren Frieden zurückzugeben. Wir
          wissen, wie es ist, von Studio zu Studio zu hetzen, Stunden um 23 Uhr
          zu planen und das Gefühl zu haben, dass sich die Mühe nicht lohnt.
          Yoga Bereit ist das System, das wir uns zu Beginn gewünscht hätten.
        </p>
      </div>
    </section>;
}